import {createContext} from 'react'

const MedicosContext = createContext()

export default MedicosContext